import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { PortalSmsSignatureFailActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function PortalSmsSignatureFail({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as PortalSmsSignatureFailActivity

  if (!activity.portalName) return null

  return <ItemWrapper notification={notification}>《{activity.portalName}》短信模板审核失败</ItemWrapper>
}
